import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import util from '../../util/util'
import '../../css/patient.scss'
import _, { upperFirst } from 'lodash'

const FilterList = (props) => {
  console.log(props.filters?.type,"props.filters?.type")
  const getCustomer = (customerid) => {
    //console.log(customerid, props?.customers);
    let customer = props?.customers?.find((c) => c.value == customerid)
    //console.log(customer);
    return customer ? customer.label : ''
  }

  return props.filters && Object.keys(props.filters).length == 1 ? (
    <Row style={{ height: '100%' }} gutter={'10'}>
      <Col style={{ alignSelf: 'center' }} span={4}>
        {'No filters applied.'}
      </Col>
    </Row>
  ) : (
    <>
      <Row hidden={!props.filters?.customer} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Clinic'}
        </Col>
        <Col span={8}>:&nbsp;{getCustomer(props.filters?.customer)}</Col>
      </Row>

      <Row hidden={!props.filters?.lastname_plain} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Last Name'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.lastname_plain}</Col>
      </Row>
      <Row hidden={!props.filters?.consent} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Consent'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.consent == 1 ? 'Yes' : 'No'}</Col>
      </Row>
      <Row hidden={!props.filters?.registered} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Registered'}
        </Col>
        <Col span={8}>
          :&nbsp;{props.filters?.registered == 1 ? 'Yes' : 'No'}
        </Col>
      </Row>
      <Row hidden={!props.filters?.type} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Patient Type'}
        </Col>
        <Col span={8}>
          :&nbsp;{props.filters?.type?upperFirst(props.filters?.type):props.filters?.type}
        </Col>
      </Row>
      <Row hidden={!props.filters?.isnew} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
         Fullfillment Type
        </Col>
        <Col span={8}>:&nbsp;
        {props.filters?.isnew==1?"Reorder":"New"}
        </Col>
      </Row>        
    </>
  )
}

export default FilterList
